import { render, staticRenderFns } from "./ConstructionGuide.vue?vue&type=template&id=80124404&scoped=true&"
import script from "./ConstructionGuide.vue?vue&type=script&lang=js&"
export * from "./ConstructionGuide.vue?vue&type=script&lang=js&"
import style0 from "./ConstructionGuide.vue?vue&type=style&index=0&id=80124404&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80124404",
  null
  
)

export default component.exports